// This is generated.  Alter it in blockGroups/lists/types/LiveDataList.js
/* eslint-disable no-unused-vars */
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary() {
    return [{}, {}];
  },
};
moduleRegistration.registerHNodeType('lists', 'LiveDataList', module.exports);
